import { apiRequestInitState } from "../constants";
import {
  REQUEST_CREATE_NEW_REQUEST,
  SUCCESS_CREATE_NEW_REQUEST,
  FAILURE_CREATE_NEW_REQUEST,
  CLEAR_NEW_REQUEST,

  REQUEST_SEND_SIGNED_REQUEST,
  SUCCESS_SEND_SIGNED_REQUEST,
  FAILURE_SEND_SIGNED_REQUEST,
  CLEAR_SIGNED_REQUEST_INFO
} from "./actions";

export const newRequest =(state = apiRequestInitState, action) => {
  switch (action.type) {
    case REQUEST_CREATE_NEW_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null
      };
    case SUCCESS_CREATE_NEW_REQUEST:
      return {
        ...state,
        isFetching: false,
        payload: action.payload,
        error: null
      };
    case FAILURE_CREATE_NEW_REQUEST:
      return {
        ...state,
        isFetching: false,
        payload: null,
        error: action.error
      };
    case CLEAR_NEW_REQUEST:
      return apiRequestInitState;

    default:
      return state;
  }
}


export const signedRequestInfo =(state = apiRequestInitState, action) => {
  switch (action.type) {
    case REQUEST_SEND_SIGNED_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null
      };
    case SUCCESS_SEND_SIGNED_REQUEST:
      return {
        ...state,
        isFetching: false,
        payload: action.payload,
        error: null
      };
    case FAILURE_SEND_SIGNED_REQUEST:
      return {
        ...state,
        isFetching: false,
        payload: null,
        error: action.error
      };
    case CLEAR_SIGNED_REQUEST_INFO:
      return apiRequestInitState;
    default:
      return state;
  }
}
